import { Card, CardBody, CardHeader } from '../../../_metronic/_partials/controls';
import { ProductCatalogWidget } from '../components/ProductCatalogWidget';

type Props = {
  cardProps?: any;
}

const ProductCatalog = ({ cardProps }: Props) => {
  return (
    <Card {...cardProps}>
      <CardHeader
        className='border-0'
        title={`Product Catalog`}
        {...cardProps}
      />
      <CardBody {...cardProps}>
        <ProductCatalogWidget />
      </CardBody>
    </Card>
  );
};

export { ProductCatalog };
